var React = require('react');

function ScrollArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}")),React.createElement("g",{"id":"Grupo_137","data-name":"Grupo 137","key":1},[React.createElement("path",{"id":"Trazado_41","data-name":"Trazado 41","className":"cls-1","d":"M87,58,43.7,101.32.35,58","key":0}),React.createElement("line",{"id":"Línea_70","data-name":"Línea 70","className":"cls-1","x1":"43.69","y1":"100.47","x2":"43.69","key":1})])]);
}

ScrollArrow.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 87.4 102.03"};

module.exports = ScrollArrow;

ScrollArrow.default = ScrollArrow;
